// extracted by mini-css-extract-plugin
export default {"blockLoading":"BlockLoading_blockLoading__Q5EHX","loader":"BlockLoading_loader__wP5eB","rot1":"BlockLoading_rot1__TWOCZ"};